import Switch from '@mui/material/Switch'
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dropdown from 'react-bootstrap/Dropdown'
import Button from '@mui/material/Button'
import dayjs, { Dayjs } from 'dayjs'
import NavBar from '../../structure/NavBar'
import Form from 'react-bootstrap/Form'
import SearchIcon from '@mui/icons-material/Search'
import InputGroup from 'react-bootstrap/InputGroup'
import AddIcon from '@mui/icons-material/Add'
import { NavBarTop } from '../../structure/NavBarTop'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useEffect, useReducer, useState } from 'react'
import AppleIcon from '@mui/icons-material/Apple'
import AndroidIcon from '@mui/icons-material/Android'
import DesktopMacIcon from '@mui/icons-material/DesktopMac'
import Image from '../../custom/Image'
import {
    updateTopHeader,
    updateLoading
} from '../../../redux/features/common/commonSlice'
import { useDispatch, useSelector } from 'react-redux'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast, showToast } from '../../constants/toaster'
import { Box, IconButton, Menu, Pagination, MenuItem } from '@mui/material'
import { Add } from './Add';
const label = { inputProps: { 'aria-label': 'Size switch demo' } }
export const List = props => {
    const [paymentGatewayFormData, setPaymentGatewayFormData] = useState({
        name: '',
        icon: '',
        parentId: '',
        slug: '',
        id: ''
    })
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [statusDropdownText, setStatusDropdownText] = useState('All')
    const [value, setValue] = useState(dayjs())
    const dispatch = useDispatch()
    const [datalist, setDatalist] = useState([])
    const [page, setPage] = useState(1);
    const [defaultWidgetOption, setDefaultWidgetOption] = useState(null)
    const [widgetKeyValueData, setWidgetKeyValueData] = useState([])
    const [showAddPaymentGateway, setShowAddPaymentGateway] = useState(false)
    const [sort_type, setSortType] = useState('createdAt')
    const [sort_order, setSortOrder] = useState(false)
    const userData = useSelector(state => state?.userData)
    const [pagerecord, setPagerecord] = useState({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
    })
    const [filterFormData, setFilterFormData] = useReducer(
        (filterFormData, newItem) => {
            return { ...filterFormData, ...newItem }
        },
        {
            id: '',
            title: '',
            duration: '',
            widgetId: '',
            description: '',
            thumbnailUrl: '',
            filterUrl: ''
        }
    )
    const handleAddPaymentGateway = () => {
        setShowAddPaymentGateway(true)
    }
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOnSubmitPaymentGatewayModel = async () => {
        console.log()
    }

    const handleHideModel = () => {
        setShowAddPaymentGateway(false)
    }

    const handleEditBanner = item => {
        setPaymentGatewayFormData(item)
        setShowAddPaymentGateway(true)
        handleClose();
        // setRadioFormData(item)
    }

    const handleChange = (event, value) => {
        setPage(value);
        setPagerecord({
            totalItems: pagerecord?.totalItems,
            totalPages: pagerecord?.totalPages,
            pageNumber: value,
            pageSize: 10,
        });
    };


    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
    };
    useEffect(() => {
        dispatch(updateTopHeader('Payment Gateway Manager'))
    }, [])

    useEffect(() => {
        getPaymentGatewayList()
    }, [sort_order, sort_type, props, page])

    const handleStatusChange = async (event, id) => {
        try {
            dispatch(updateLoading(true))
            let path = urls.changeFilterStatus + '/' + id
            let res = await ApiCaller.put({}, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                showToast(response?.message)
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    const getPaymentGatewayList = async (pageNo = pagerecord.pageNumber) => {
        try {
            dispatch(updateLoading(true))
            let postJson = {
                searchText: '',
                pageNumber: pageNo - 1 || 0,
                pageSize: pagerecord.pageSize || 10,
                shortingField: sort_type,
                asc: sort_order,
                parentId: 0
            }
            let path = urls.paymentGatewayList
            let res = await ApiCaller.post(postJson, path, userData?.access_token)
            const response = await res.response.json()
            if (response.status == 200) {
                dispatch(updateLoading(false))
                setDatalist(response?.data?.items)
                setPagerecord({
                    totalItems: response?.data?.response?.totalItems,
                    totalPages: response?.data?.response?.totalPages,
                    pageNumber: pageNo,
                    pageSize: 10
                })
            } else {
                dispatch(updateLoading(false))
                showDangerToast(response.message)
            }
        } catch (error) {
            dispatch(updateLoading(false))
            console.error(error)
            showDangerToast(error.message)
        }
    }

    return (
        <>
            <NavBar />
            <div className='main-content'>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                <div className='container-fluid mt--7'>
                    <div className='row'>
                        <div className='col text-left'>
                            <div className='card shadow'>
                                <div className='card-header border-0'>
                                    <div className='row align-items-center text-left'>
                                        <div className='col'>
                                            <h3 className='mb-0'>Payment Gateway Manager</h3>
                                        </div>
                                        <div className='col text-right'>
                                            {userData.admin ? (
                                                <a
                                                    onClick={() => handleAddPaymentGateway()}
                                                    className='btn btn-sm btn-primary text-white'
                                                >
                                                    <AddIcon />
                                                    Add New
                                                </a>
                                            ) : <></>}
                                        </div>
                                    </div>
                                </div>
                                <div className='card-header border-0'>
                                    <div className='row align-items-center text-left'>
                                        <div className='col-md-3'>
                                            <InputGroup
                                                className='mb-2'
                                                style={{ borderRadius: '10px' }}
                                            >
                                                <Form.Control
                                                    placeholder='Search by Keyword'
                                                    aria-label='Amount (to the nearest dollar)'
                                                />
                                            </InputGroup>
                                        </div>
                                        <div className='col-md-3 mb-2'>
                                            <Button
                                                variant='contained'
                                                className='custom-filter-btn'
                                            >
                                                Filter
                                            </Button>
                                            <Button
                                                variant='contained'
                                                className='ml-2 custom-filter-btn'
                                            >
                                                Reset
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                <div className='table-responsive'>
                                    <table className='table align-items-center table-flush'>
                                        <thead className='thead-light'>
                                            <tr>
                                                <th scope='col'>S/No.</th>
                                                <th scope='col'>Name</th>
                                                <th scope='col'>Icon</th>
                                                <th scope='col'>Child</th>
                                                <th scope='col'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {datalist?.map((data, i) => {
                                                const startIndex =
                                                    (pagerecord.pageNumber - 1) *
                                                    pagerecord.pageSize
                                                return <tr key={i}>
                                                    <td>{startIndex + i + 1}</td>
                                                    <td>{data?.name}</td>
                                                    <td><Image
                                                        image={{
                                                            id: i,
                                                            src: data?.icon
                                                        }}
                                                        width='80px'
                                                        height='auto
'
                                                    /></td>
                                                    <td>{data?.child?.length}</td>
                                                    <td className='text-right'>
                                                        <IconButton size="small" onClick={(e) => handleClick(e, data)}>
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        <Menu
                                                            anchorEl={anchorEl}
                                                            open={open}
                                                            onClose={handleClose}
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                                        >
                                                            {(userData.admin) && (
                                                                <MenuItem
                                                                    onClick={() => handleEditBanner(data)}
                                                                >
                                                                    Edit
                                                                </MenuItem>
                                                            )}
                                                        </Menu>
                                                    </td>
                                                </tr>
                                            })}

                                        </tbody>
                                    </table>
                                </div>
                                {datalist && datalist.length > 0 ? (
                                    <div className="card-footer py-4">
                                        <Box display="flex" justifyContent="right" alignItems='center'>
                                            <span>Total record: {pagerecord?.totalItems}</span>
                                            <Pagination
                                                className="custom-pagination-class"
                                                count={pagerecord?.totalPages}
                                                page={page}
                                                onChange={handleChange}
                                                color="secondary"
                                            />
                                        </Box>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* <Footer /> */}
                </div>
                <Add
                    show={showAddPaymentGateway}
                    paymentGatewayFormData={paymentGatewayFormData}
                    setPaymentGatewayFormData={setPaymentGatewayFormData}
                    onSubmit={handleOnSubmitPaymentGatewayModel}
                    onHide={() => handleHideModel()}
                />
            </div>
        </>
    )
}
